import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Autocomplete,
  Switch,
  FormGroup,
  Stack,
  Checkbox,
  FormControlLabel, MenuItem,
} from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import * as XLSX from "xlsx";
import * as React from "react";
import { useNavigate } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import KeywordBusSample from "../Assets/Keyword_bus_stop.png";
import KeywordTransitSample from "../Assets/Keyword_transit.png";
import SmartSearchSample from "../Assets/Smart_search.png";
import SuccessfulStamp from "../Assets/success_stamp.jpeg";
import HomeFrame from "../Components/HomeFrame";
import Footer from "../Components/Footer";
import CheckSimilarityTable from "../Components/CheckSimilarityTable";
import {backendCall, scoreCall} from "../utils/Network";

import "../CSS/Layout.css";
import "../CSS/SuccessfulAwards.css";

export default function SuccessfulAwards() {
  const [description, setDescription] = useState("");
  const [passDescription, setPassDescription] = useState("");
  const [searched, setSearched] = useState(false);
  const [open, setOpen] = useState(false);
  const [stateList, setStateList] = useState(null);
  const [state, setState] = useState([]);
  const [passState, setPassState] = useState([]);
  const [smartSearch, setSmartSearch] = useState(false);
  const [exportExcel, setExportExcel] = useState(false);
  const label = smartSearch === false ? "Keywords" : "Description";
  const [includeDocs, setIncludeDocs] = useState(false);
  const [passDocs, setPassDocs] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [enableExport, setEnableExport] = useState(false);

  const placeholder =
    smartSearch === false
      ? "Please enter your keywords and separate by spaces."
      : "Please enter your project description to search for similar successful awards.";

  const fetchSimilarProjects = () => {
    setSearched(true);
    setExportExcel(false);
    setPassDocs(includeDocs);
    setPassDescription(description);
    setPassState(state);
    setEnableExport(true);
  };


  const fetchExportProjects = () => {
    setSearched(true);
    setPassDocs(includeDocs);
    setPassDescription(description);
    setPassState(state);
    setExportExcel(true);
  };




  const handleSearchChange = () => {
    setSmartSearch(!smartSearch);
  };

  const handleExportChange = () => {

    fetchExportProjects();
    setExportExcel(!exportExcel);


  };







    useEffect(() => {
      const fetchStateList = async () => {
        let response;
        if (stateList === null) {
          response = await backendCall.get("/state");
          if (Array.isArray(response.data) && response.data[0]["state_id"]) {
            setStateList(response.data);
          } else {
            console.log("Invalid State", response.data);
          }
        }
      };
      fetchStateList();
    }, []);


    const stateSelection = useMemo(() => {
      if (!stateList) return <></>;
      return (
          <Autocomplete
              multiple
              filterSelectedOptions
              disableCloseOnSelect
              sx={{my: 2}}
              options={stateList}
              value={state}
              getOptionLabel={(option) => option.state_name}
              onChange={(event, newState) => {
                setState(newState);
              }}
              renderInput={(params) => (
                  <TextField {...params} label="Select States"/>
              )}
              renderOption={(props, option) => (
                  <li {...props} key={option.state_id} label={option.state_name}>
                    {option.state_name}
                  </li>
              )}
          />
      );
    }, [stateList, state]);

    const dialog = (
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={open}
            onClose={() => {
              setOpen(false);
            }}
        >
          <DialogTitle>
            <IconButton
                onClick={() => {
                  setOpen(false);
                }}
                sx={{
                  position: "absolute",
                  left: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
            >
              <CloseIcon/>
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography sx={{my: 2}}>Keyword Search: bus stop</Typography>
            <Box
                component="img"
                sx={{height: "100%", width: "100%"}}
                src={KeywordBusSample}
            />
            <Typography sx={{my: 2}}>Keyword Search: transit</Typography>
            <Box
                component="img"
                sx={{height: "100%", width: "100%"}}
                src={KeywordTransitSample}
            />
            <Typography sx={{my: 2}}>
              Smart Search: The University of Maryland will receive funds to
              purchase transit vehicles
            </Typography>
            <Box
                component="img"
                sx={{height: "100%", width: "100%"}}
                src={SmartSearchSample}
            />
          </DialogContent>
          <DialogActions style={{justifyContent: "center"}}>
            <Button
                className="button"
                variant="contained"
                color="secondary"
                onClick={() => {
                  setOpen(false);
                }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
    );

    return (
        <>
          <HomeFrame currentPageName="Search Successful Awards"/>
          <Box className="content-body">
            <Box>
              <Box className="awards-description">
                <Typography>
                  Public agencies can improve their grant applications by learning
                  from previous applications and successful awards. The IIJA
                  Launchpad collects successful project applications since 2021 and
                  allows quick project matching by key project features using
                  machine learning and natural language processing techniques. The
                  process is simple. Just enter keywords or sentences from your
                  project and the IIJA Launchpad database will identify similar
                  projects that were awarded funding. The smart search allows you to
                  enter more complete project descriptions and features for AI-based
                  search results. Selected project narratives and supporting
                  documents are available for you to dive into the details of those
                  successful awards. This database helps public agencies determine
                  some “best-fit” funding programs and learn from successful
                  applications.
                </Typography>
                <Box
                    component="img"
                    sx={{height: "100px", objectFit: "contain", m: 2}}
                    src={SuccessfulStamp}
                />
              </Box>

              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                    sx={{fontWeight: smartSearch === false ? "bold" : "regular"}}
                >
                  Keyword Search
                </Typography>
                <FormControlLabel
                    control={
                      <Switch
                          color="secondary"
                          checked={smartSearch}
                          onChange={handleSearchChange}
                      />
                    }
                />
                <Typography
                    sx={{fontWeight: smartSearch === true ? "bold" : "regular"}}
                >
                  Smart Search
                </Typography>
              </Stack>

              <FormControlLabel
                  control={
                    <Checkbox
                        color="secondary"
                        checked={includeDocs}
                        onChange={() => {
                          setIncludeDocs(!includeDocs);
                        }}
                    />
                  }
                  label="Including Application Documents"
                  // labelPlacement="start"
              />

              <Box display="flex" alignItems="center">
                <Typography>Example search entries: </Typography>
                <IconButton
                    size="small"
                    onClick={() => {
                      setOpen(true);
                    }}
                >
                  <HelpOutlineIcon/>
                </IconButton>
              </Box>

              {stateSelection}
              <Box display="flex">
                <TextField
                    style={{width: "80%"}}
                    hiddenLabel
                    InputLabelProps={{shrink: true}}
                    sx={{my: 2, mr: 2}}
                    label={label}
                    placeholder={placeholder}
                    variant="outlined"
                    onChange={(event) => {
                      setDescription(event.target.value);
                    }}
                    value={description}
                />
                <Button
                    sx={{ mt: 2,   mr: 2,  width: "20%", height: "56px" }}
                    variant="contained"
                    onClick={fetchSimilarProjects}
                    color="secondary"
                >
                  Search
                </Button>
                <Button
                    sx={{mt: 2, width: "20%", height: "56px"}}
                    variant="contained"
                    onClick={handleExportChange}
                    disabled={!enableExport}
                    color="primary"
                >
                  Export
                </Button>

              </Box>
              {searched && (
                  <CheckSimilarityTable
                      description={passDescription}
                      maxQuery={30}
                      state={passState}
                      smartSearch={smartSearch}
                      includeDocs={passDocs}
                      exportExcel={exportExcel}
                  />
              )}




              <Divider
                  sx={{backgroundColor: "gray", width: "100%", marginTop: "40px"}}
              />
              <Typography mt="40px" color="gray">
                The Build America Center has supported public agencies for a variety
                of activities including grant applications, plan development,
                funding strategy, project delivery, and federal compliance. Contact
                us so we can help you start your funding application.
              </Typography>
            </Box>
            {dialog}
          </Box>
          <Footer/>
        </>
    );
  }
